module.exports = __webpack_public_path__ + "fonts/iconfont.6644b5b6.ttf";